import { Reveal, Overline } from "./Reveal";

const chapters = [
  {
    n: "01",
    title: "Discretion is our founding principle.",
    body: "Membership is never advertised and never sold. Access is extended by invitation to a limited circle, protecting the privacy and privilege of those we serve.",
  },
  {
    n: "02",
    title: "Access, where others meet a closed door.",
    body: "The reservation that cannot be made. The table that does not exist. The object no longer in production. Our relationships turn the impossible into a quiet confirmation.",
  },
  {
    n: "03",
    title: "A single point of contact, anywhere on earth.",
    body: "One dedicated lifestyle manager who learns your taste, anticipates your needs, and coordinates a global network of specialists on your behalf — day or night.",
  },
];

export const Manifesto = () => {
  return (
    <section
      id="manifesto"
      data-testid="manifesto-section"
      className="relative bg-ivory py-28 md:py-40"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-12 gap-y-8 mb-20 md:mb-28">
          <div className="md:col-span-4">
            <Reveal>
              <Overline>The Manifesto</Overline>
            </Reveal>
          </div>
          <div className="md:col-span-8">
            <Reveal delay={0.1}>
              <h2 className="font-serif font-light text-navy text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
                We are not a service.
                <br />
                <span className="italic text-gold">We are a standard.</span>
              </h2>
            </Reveal>
          </div>
        </div>

        <div className="space-y-px">
          {chapters.map((c, i) => (
            <Reveal key={c.n} delay={i * 0.08}>
              <div className="grid md:grid-cols-12 gap-6 md:gap-10 border-t border-navy/10 py-12 md:py-16 group">
                <div className="md:col-span-2">
                  <span className="font-serif text-5xl md:text-6xl text-gold/70 leading-none">
                    {c.n}
                  </span>
                </div>
                <div className="md:col-span-6">
                  <h3 className="font-serif font-light text-navy text-2xl md:text-3xl lg:text-4xl leading-tight tracking-tight">
                    {c.title}
                  </h3>
                </div>
                <div className="md:col-span-3 md:col-start-10">
                  <p className="font-sans font-light text-navyAccent/80 text-base leading-relaxed">
                    {c.body}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
